import React from "react";
import { AiOutlineClose } from "react-icons/ai";

interface IProps {
  handleClosePopup: () => void;
  isPopupShowing: boolean;
  numberOfSeats: number;
  numberOfRaces: number;
}

const NoUnder12AvailablePopup: React.FC<IProps> = ({ handleClosePopup, isPopupShowing }) => {
  return (
    <>
      {isPopupShowing && (
        <div className="tw-fixed tw-z-[1000] tw-inset-0 tw-flex tw-items-center tw-justify-center tw-bg-gray-900 tw-bg-opacity-50">
          <div className="tw-mx-[20px] lg:tw-mx-0">
            <div className="tw-bg-[#393B41] lg:tw-max-w-[600px] tw-w-full tw-mx-auto tw-rounded-[15px] tw-shadow-lg tw-overflow-hidden tw-transform tw-transition-all tw-duration-300 tw-scale-100">
              <div className="tw-py-[10px] tw-px-[10px]">
                <div className="tw-flex tw-justify-end">
                  <button className="tw-text-gray-600 tw-text-lg tw-p-2 tw-hover:text-gray-800 tw-focus:tw-outline-none" onClick={handleClosePopup}>
                    <AiOutlineClose className="tw-w-[30px] tw-h-[30px] tw-text-white tw-font-[400]" />
                  </button>
                </div>
                <div className="tw-flex tw-justify-center tw-items-center">
                  <div className="tw-text-white tw-text-center tw-p-0 lg:tw-pb-[30px] lg:tw-px-[40px]">
                    <div className="tw-mb-[20px]">
                      <h2 className="tw-text-[24px] tw-font-[700] tw-mb-[16px] tw-text-white">
                        No Under 12 Sessions Available
                      </h2>
                      <p>
                      There are currently no under 12 races available. Check out our{" "}
                      <a className="tw-text-[#9d62fe]" href={`https://hyperkarting.com.au/pages/junior-track?redirect=true`}>
                        Junior Track
                      </a>{" "}
                      instead (only available for racers 120cm+). 
                      For groups larger than 8, please contact us at{" "} 
                      <a className="tw-text-[#9d62fe]" href="mailto:hello@hyperkarting.com.au">
                        hello@hyperkarting.com.au 
                      </a>
                      {" "}or give us a call at{" "}
                      <a className="tw-text-[#9d62fe]" href="tel:+61283114124">
                        (02) 8311 4124
                      </a>
                       .
                    </p>
                    </div>

                    <button
                      onClick={handleClosePopup}
                      className="tw-mt-[20px] tw-mb-[30px] lg:tw-mb-0 tw-mx-auto tw-flex tw-justify-center tw-items-center tw-w-fit tw-h-[57px] tw-overflow-hidden tw-py-[16px] tw-px-[40px] tw-font-bold tw-text-[18px] tw-rounded-[100px] tw-text-white tw-bg-[linear-gradient(71deg,#a852ff_28.13%,#7886ff)]"
                    >
                      OK
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default NoUnder12AvailablePopup; 